module.exports = __webpack_public_path__ + "static/img/matter_lun3.fd68407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matter/matter_lun3.jpg
// module id = XtJe
// module chunks = 1